'use client';

import { IProductDetail } from '@/api/types/public';
import Image from '@/components/Image';
import SwiperNavigationButtons from '@/components/SwiperNavigation';
import React, { useRef } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslations } from 'next-intl';

interface GoodsFeatureIntroProps {
  featureIntroduction: IProductDetail['feature_introduction'];
}

const GoodsFeatureIntro: React.FC<GoodsFeatureIntroProps> = ({ featureIntroduction }) => {
  const swiperRef = useRef<SwiperType | null>(null);
  const t = useTranslations('goodsDetail');
  if (!featureIntroduction || featureIntroduction.length === 0) {
    return null;
  }

  return (
    <div className="might-like goods-feature-intro w-full mt-[60px] pb-[60px]">
      <p className="text-[32px] font-bb text-center mb-[32px] leading-[39px]">
        {t('endToEndQuality')}
      </p>
      <div className="swiper-nav-container relative w-[95vw] mx-auto box-border">
        <Swiper
          modules={[Navigation]}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          observer
          observeParents
          observeSlideChildren
          slidesPerView="auto"
          spaceBetween={16}
          navigation={{
            nextEl: '.goods-feature-intro-next',
            prevEl: '.goods-feature-intro-prev',
          }}
          className="h-full items-stretch"
        >
          {featureIntroduction.map((item, index) => {
            const slideStyle = {
              width: '23.12vw',
              minWidth: '292px',
            };
            return (
              <SwiperSlide
                key={index}
                className="might-like-item flex justify-center items-center"
                style={slideStyle}
              >
                <div className="item-box w-full flex flex-col justify-between items-center">
                  <div className="img-box" style={slideStyle}>
                    <Image
                      src={item.img}
                      alt={item.title}
                      width={444}
                      height={400}
                      className="h-auto object-contain select-none"
                      style={{ width: slideStyle.width, minWidth: slideStyle.minWidth }}
                    />
                  </div>
                  <div className="text-box w-full">
                    {item.title && (
                      <div className="title font-bb font-normal text-20 text-[#282828] leading-24 text-left mt-[22px]">
                        {item.title}
                      </div>
                    )}
                    {item.description && (
                      <div className="desc font-ir text-14 text-[#282828] leading-[22px] text-left break-words mt-[5px]">
                        {item.description}
                      </div>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {/* Navigation Buttons */}
        <SwiperNavigationButtons
          navigationPrefix="goods-feature-intro"
          prevButtonPosition="left-16"
          nextButtonPosition="right-16"
        />
      </div>
    </div>
  );
};

export default GoodsFeatureIntro;
